export const translate = ({ id, intl, ...rest }) => {
  if (typeof id !== 'string' || !id) return '';

  /**
   *  No curly brackets -> the string is not a key, just return it.
   */
  if (!id.includes('{') && !id.includes('}')) {
    return id;
  }

  const regex = /{([^}]+)}/g;
  const { values, ...descriptorProps } = rest;

  /**
   *  someString.matchAll(/regex/) extracts all the translation keys from that string.
   *
   *  For the string `whitelabel {searchbar.month0} omio {ferret.placeholder.to} aaa {FOOTER.PRIVACY} bbb`,
   *  the match result will be an array of arrays with the following structure:
   *
   *  [
   *    ["{searchbar.month0}", "searchbar.month0"],
   *    ["{FOOTER.PRIVACY}", "FOOTER.PRIVACY"],
   *    ["{ferret.placeholder.to}", "ferret.placeholder.to"]
   *  ]
   *
   *  Each internal array has two elements: the key surrounded by curly brackets (used for search & replace)
   *  and the same key without them (the actual value).
   *
   *
   *  matchAll() function returns an iterator and thus need to be converted into array
   */
  return [...id.matchAll(regex)].reduce((acc, [curlyTemplate, actualValue]) => {
    const descriptor = {
      id: actualValue,
      defaultMessage: ' ',
      ...descriptorProps,
    };
    const translation = values
      ? intl.formatMessage(descriptor, values)
      : intl.formatMessage(descriptor);

    return acc.replace(curlyTemplate, translation);
  }, id);
};
